import { useMemo } from "react";

export const useFavoritesTableHead = () =>
  useMemo(() => ["", "cart.item_name", "common.points", ""], []);
